import React from 'react';
import styles from './QuantityInput.module.scss';
import { useState, useEffect } from 'react';
import { useSharedCart } from '../../entrypoints/theme';

export default function QuantityInput({ cartKey, quantity }) {
  const { cartState, updateQuantity } = useSharedCart();
  const [quantityValue, setQuantityValue] = useState(0);
  const [customKey, setCustomKey] = useState(null);

  useEffect(() => {
    if (cartState && cartState.items) {
      const cartItem = cartState.items.find(item => item.key === cartKey);
      setQuantityValue(cartItem ? cartItem.quantity : 0);
      setCustomKey(cartItem ? cartItem.properties.custom_key : null);
    } else {
      setQuantityValue(quantity);
    }
  }, [cartState, quantity]);

  const handleButtonClick = (e, newQuantity) => {
    e.preventDefault();
    e.stopPropagation();
    const updatedQuantity = Math.max(0, parseInt(newQuantity, 10));
    setQuantityValue(updatedQuantity);
    if (cartKey) {
      updateQuantity(cartKey, updatedQuantity, customKey);
    }
  }

  const handleInputChange = (e) => {
    const rawValue = e.target.value;
    const updatedQuantity = rawValue === '' ? '' : Math.max(0, parseInt(rawValue, 10));
    setQuantityValue(updatedQuantity);
  }

  const handleBlur = (e) => {
    const finalQuantity = quantityValue === '' ? 0 : quantityValue;
    setQuantityValue(finalQuantity);
    if (cartKey) {
      const cartItem = cartState?.items?.find(item => item.key === cartKey);
      const currentCartQuantity = cartItem ? cartItem.quantity : 0;
      if (finalQuantity !== currentCartQuantity) {
        updateQuantity(cartKey, finalQuantity, customKey);
      }
    }
  }

  return (
    <div className={styles.quantityInput}>
      <button onClick={(e) => handleButtonClick(e, quantityValue - 1)} disabled={quantityValue <= 0} aria-label="Decrease quantity"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path d="M20.625 12C20.625 12.0995 20.5855 12.1948 20.5152 12.2652C20.4448 12.3355 20.3495 12.375 20.25 12.375H3.75C3.65054 12.375 3.55516 12.3355 3.48484 12.2652C3.41451 12.1948 3.375 12.0995 3.375 12C3.375 11.9005 3.41451 11.8052 3.48484 11.7348C3.55516 11.6645 3.65054 11.625 3.75 11.625H20.25C20.3495 11.625 20.4448 11.6645 20.5152 11.7348C20.5855 11.8052 20.625 11.9005 20.625 12Z" fill="currentColor"></path>
      </svg></button>
      <input
        type="number"
        aria-label="Quantity"
        onChange={handleInputChange}
        onBlur={handleBlur}
        value={quantityValue}
        min="0"
      />
      <button onClick={(e) => handleButtonClick(e, quantityValue + 1)} aria-label="Increase quantity"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path d="M20.625 12C20.625 12.0995 20.5855 12.1948 20.5152 12.2652C20.4448 12.3355 20.3495 12.375 20.25 12.375H12.375V20.25C12.375 20.3495 12.3355 20.4448 12.2652 20.5152C12.1948 20.5855 12.0995 20.625 12 20.625C11.9005 20.625 11.8052 20.5855 11.7348 20.5152C11.6645 20.4448 11.625 20.3495 11.625 20.25V12.375H3.75C3.65054 12.375 3.55516 12.3355 3.48484 12.2652C3.41451 12.1948 3.375 12.0995 3.375 12C3.375 11.9005 3.41451 11.8052 3.48484 11.7348C3.55516 11.6645 3.65054 11.625 3.75 11.625H11.625V3.75C11.625 3.65054 11.6645 3.55516 11.7348 3.48484C11.8052 3.41451 11.9005 3.375 12 3.375C12.0995 3.375 12.1948 3.41451 12.2652 3.48484C12.3355 3.55516 12.375 3.65054 12.375 3.75V11.625H20.25C20.3495 11.625 20.4448 11.6645 20.5152 11.7348C20.5855 11.8052 20.625 11.9005 20.625 12Z" fill="currentColor"></path>
      </svg></button>
    </div>
  );
}
